import React from 'react';
import { TableCell } from 'components/Hospital/PaginationForms';
import { clPatientInfoTableWidth } from 'constants/pagination';
import moment from 'moment';
import styled from 'styled-components';
import { ICLDailyStatistics } from 'models/CL/CLBasicInterface';
import { Body3Regular, Body3SemiBold } from 'styles/Global/typography';
import { BackgroundColor, BorderColor, PrimaryColor, TextColor, WarningColor } from 'styles/Global/colorSemantic';
import IcSuccessNone from 'assets/Icons/IcSuccessNone';

const CLPatientInfoTableBody = ({ currentData }: { currentData?: ICLDailyStatistics[] }) => {
    // 날짜순으로 최신부터 정렬 (내림차순)
    const data = currentData?.sort((a, b) => {
        return moment(b.date, 'YYYYMMDD').valueOf() - moment(a.date, 'YYYYMMDD').valueOf();
    });

    return (
        <BodyContainer>
            {data?.map((item, idx) => {
                const foodData = item.foodCalories !== 0;
                const exerciseData = item.exerciseCalories !== 0;
                const hydrateData = item.hydrateIntake !== 0;
                const allUndefinedData = !foodData && !exerciseData && !hydrateData;

                const foodSuccess = item.targetCalories > item.foodCalories && item.foodCalories > 500;
                const exerciseSuccess = item.exerciseCalories >= item.targetExerciseCalories;

                return (
                    <ListWrapper key={idx} $backgroundColor={allUndefinedData || item.isSuccess ? BackgroundColor.color_background_white : BackgroundColor.color_background_warning}>
                        <TableCell $width={clPatientInfoTableWidth[0]} $type='date' $height='60px'>
                            <BaseText $success={true}>{moment(item.date, 'YYYYMMDD').format('YYYY.MM.DD (ddd)')}</BaseText>
                        </TableCell>
                        <TableCell $width={clPatientInfoTableWidth[1]} $height='60px'>
                            {allUndefinedData && <Body3Regular $color={TextColor.color_text_info}>기록없음</Body3Regular>}
                            {!allUndefinedData && item.isFast && <BaseText $success={false}>단식</BaseText>}
                            {!allUndefinedData && !item.isFast && (
                                <BaseText $success={foodSuccess}>
                                    {item.foodCalories} <Body3Regular $color={TextColor.color_text_disabled}> / </Body3Regular>
                                    <Body3Regular $color={TextColor.color_text_light}> {item.targetCalories}kcal</Body3Regular>
                                </BaseText>
                            )}
                        </TableCell>
                        <TableCell $width={clPatientInfoTableWidth[2]} $height='60px' $show='always'>
                            {allUndefinedData && <Body3Regular $color={TextColor.color_text_info}>기록없음</Body3Regular>}
                            {!allUndefinedData && (
                                <BaseText $success={exerciseSuccess}>
                                    {item.exerciseCalories} <Body3Regular $color={TextColor.color_text_disabled}> / </Body3Regular>
                                    <Body3Regular $color={TextColor.color_text_light}> {item.targetExerciseCalories}kcal</Body3Regular>
                                </BaseText>
                            )}
                        </TableCell>
                        <TableCell $width={clPatientInfoTableWidth[3]} $height='60px'>
                            {allUndefinedData && <Body3Regular $color={TextColor.color_text_info}>기록없음</Body3Regular>}
                            {!allUndefinedData && (
                                <BaseText $success={true}>
                                    {item.hydrateIntake} <Body3Regular $color={TextColor.color_text_disabled}> / </Body3Regular>
                                    <Body3Regular $color={TextColor.color_text_light}> {item.targetHydrate}ml</Body3Regular>
                                </BaseText>
                            )}
                        </TableCell>
                        <TableCell $width={clPatientInfoTableWidth[4]} $height='60px'>
                            <BaseText $success={item.isSuccess}>
                                {allUndefinedData && ''}
                                {!allUndefinedData &&
                                    (item.isSuccess ? (
                                        <FlexWrapper>
                                            성공 <IcSuccessNone />
                                        </FlexWrapper>
                                    ) : (
                                        '실패'
                                    ))}
                            </BaseText>
                        </TableCell>
                    </ListWrapper>
                );
            })}
        </BodyContainer>
    );
};

export default CLPatientInfoTableBody;

const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 752px;
    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 0;
        height: 0;
        display: none;
    }
`;

const BaseText = styled(Body3SemiBold)<{ $success: boolean }>`
    color: ${(props) => (props.$success ? TextColor.color_text_normal : WarningColor.color_warning_normal)};
`;

const ListWrapper = styled.div<{ $backgroundColor?: string }>`
    display: flex;
    width: 100%;
    height: 60px;
    border-bottom: 1px solid ${BorderColor.color_border_neutral};
    background-color: ${(props) => props.$backgroundColor || 'transparent'};

    & > div:last-child {
        border-right: none !important;
        max-width: 60px;
    }
    &:last-child {
        border-bottom: none;
    }
`;

const FlexWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${PrimaryColor.color_primary_normal};
`;
